// extracted by mini-css-extract-plugin
export default {"blockquoteWrapper":"banner_blockquoteWrapper__hmFnv","blockquote":"banner_blockquote__8CMcz","quoteHeading":"banner_quoteHeading__a4mLF","quoteAuthor":"banner_quoteAuthor__t0Kuu"};